// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.install-popup {
    position: fixed;
    bottom: 20px;
    right: 20px;
    background: #ffffff;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
    padding: 20px;
    z-index: 1000;
    max-width: 300px;
  }
  
  .popup-content {
    text-align: center;
  }
  
  .popup-content h2 {
    font-size: 18px;
    color: #333;
    margin-bottom: 10px;
  }
  
  .popup-content p {
    font-size: 14px;
    color: #555;
    margin-bottom: 15px;
  }
  
  .popup-content button {
    margin: 5px;
    padding: 10px 15px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .popup-content button:first-child {
    background-color: #007bff;
    color: #ffffff;
  }
  
  .popup-content button:last-child {
    background-color: #ccc;
    color: #333;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/InstallPopup.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb","sourcesContent":[".install-popup {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    background: #ffffff;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);\n    padding: 20px;\n    z-index: 1000;\n    max-width: 300px;\n  }\n  \n  .popup-content {\n    text-align: center;\n  }\n  \n  .popup-content h2 {\n    font-size: 18px;\n    color: #333;\n    margin-bottom: 10px;\n  }\n  \n  .popup-content p {\n    font-size: 14px;\n    color: #555;\n    margin-bottom: 15px;\n  }\n  \n  .popup-content button {\n    margin: 5px;\n    padding: 10px 15px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n  \n  .popup-content button:first-child {\n    background-color: #007bff;\n    color: #ffffff;\n  }\n  \n  .popup-content button:last-child {\n    background-color: #ccc;\n    color: #333;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
